module.exports = __webpack_public_path__ + "static/media/partitions_material_60yd_y.575c8250.csv";